export default "__VITE_ASSET__4e6ad5ae__$_?component__"